export const NORMAL = 'NORMAL';
export const REDUCED = 'REDUCED';
